import React, { useState } from 'react';
import axios from 'axios';
export default function ServicePanel({ projectName }) {
  const [logs, setLogs] = useState('');
  const start = async () => {
    await axios.post(`/api/projects/${projectName}/start`);
    alert('服务已启动');
  };
  const stop = async () => {
    await axios.post(`/api/projects/${projectName}/stop`);
    alert('服务已停止');
  };
  const getLogs = async () => {
    const res = await axios.get(`/api/projects/${projectName}/logs`);
    setLogs(res.data.logs);
  };
  return (
    <div className="p-4">
      <h3 className="font-bold mb-2">服务管理</h3>
      <div className="flex gap-2 mb-4">
        <button onClick={start} className="bg-green-600 px-3 py-1 rounded">启动</button>
        <button onClick={stop} className="bg-red-600 px-3 py-1 rounded">停止</button>
        <button onClick={getLogs} className="bg-gray-600 px-3 py-1 rounded">刷新日志</button>
      </div>
      <pre className="bg-black text-green-400 p-2 h-64 overflow-auto text-xs">{logs}</pre>
    </div>
  );
}
